export default "__VITE_ASSET__1c565a23__"